import React from 'react';
import { personalQuotes, personalNotes, motivations, images } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
import { PortraitFrame } from '../components/PortraitFrame';
export function PersonalLife() {
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-198" data-mp="j8fms49yaz00">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-199" data-mp="f7dmrl87miwz">
        <PageHeader overline="Personal Life" title="Off the org chart" description="The convictions behind the work: family, community, and a long-held belief that how a company treats people is a measurable business fact." data-id="element-200" data-mp="f4rf7llbk3er" />

        <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-16 lg:items-center" data-id="element-201" data-mp="12uu8g50yzfey">
          <div className="lg:col-span-5" data-id="element-202" data-mp="xw0sm5y7ncbm">
            <PortraitFrame src={images.offDuty} alt="Samanntha DuBridge photographed outdoors, off duty" backdropClass="bg-brass" className="mx-auto w-full max-w-[320px]" aspectClass="aspect-[4/5]" data-id="element-203" data-mp="xzettav51fhh" />
          </div>

          <div className="lg:col-span-7 space-y-10" data-id="element-204" data-mp="1vju3ulveockt">
            {personalQuotes.map(item => <blockquote key={item.quote} data-id="element-205" data-mp="20infe8r4ttic">
                <p className="font-display text-2xl leading-snug text-navy lg:text-[28px]" data-id="element-206" data-mp="1mm1j326x0cq1">
                  “{item.quote}”
                </p>
                <footer className="mt-4 font-sans text-sm text-emerald" data-id="element-207" data-mp="1rmfumu7q64st">{item.context}</footer>
              </blockquote>)}
          </div>
        </div>

        <div className="mt-24 space-y-20" data-id="element-208" data-mp="1hn70o1cv0q6g">
          {personalNotes.map((note, index) => <article key={note.title} className="grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-209" data-mp="13vs8b3x2bcmq" data-mpi={index}>
              <div className={index % 2 === 0 ? 'lg:col-span-6' : 'lg:col-span-6 lg:order-2'} data-id="element-210" data-mp="17tzonxnm6bxe">
                <PortraitFrame src={note.image} alt={note.caption} caption={note.caption} backdropClass={index % 2 === 0 ? 'bg-emerald' : 'bg-navy'} archClass="rounded-t-[7rem]" aspectClass="aspect-[4/3]" data-id="element-211" data-mp="tynt5o1mwhff" />
              </div>
              <div className={index % 2 === 0 ? 'lg:col-span-6' : 'lg:col-span-6 lg:order-1'} data-id="element-212" data-mp="2rrq7zroaez00">
                <h2 className="font-display text-3xl leading-snug text-navy" data-id="element-213" data-mp="2mu80m5px4ru4">{note.title}</h2>
                <p className="mt-5 max-w-xl font-sans text-[17px] leading-relaxed text-navy-600" data-id="element-214" data-mp="3jjz5myvu5xe6">
                  {note.body}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-24" data-id="element-215" data-mp="3ahyaq8o2rnfo">
          <h2 className="font-display text-3xl text-navy" data-id="element-216" data-mp="3ah6gb167rvqz">What motivates the work</h2>
          <div className="mt-8 grid gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-217" data-mp="35jejptumjlgg">
            {motivations.map(item => <article key={item.title} className="flex flex-col bg-parchment-light p-8" data-id="element-218" data-mp="1z55hsujjssy1">
                <h3 className="font-display text-xl leading-snug text-navy" data-id="element-219" data-mp="1u3g6rewbsf9y">{item.title}</h3>
                <p className="mt-auto pt-5 font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-220" data-mp="1k2dxy72gfvjx">
                  {item.body}
                </p>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}